export const scrollToElement = (elementId: string | undefined | null) => {
  if (!elementId) return;
  const element = document.getElementById(elementId);
  const fixed1 = document.getElementById('header')?.offsetHeight || 0;
  const fixed2 =
    document.getElementById('report-actions-container')?.offsetHeight || 0;
  const fixedHeight = fixed1 + fixed2;
  if (element) {
    const position = element.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = position - fixedHeight;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }
};
